module.exports = __webpack_public_path__ + "img/congrates.1806113a.svg";